export default __webpack_public_path__ + "static/media/491.0edd4c83.png";